<template>
    <div class="workflow-editor">
        <!-- <div> wordflow editor</div> -->
        <iframe v-if="editorUrl" class="detailUrl-page" :src="editorUrl" frameborder="0"></iframe>
        <!-- :title="taskData.taskName" -->
        <el-dialog
            custom-class="task-edit-dialog"
            :title="titleView"
            :visible.sync="isShowEleEditor"
            :before-close="handleCloseEleEditor"
            :key="loadTimer"
            top="2vh"
            width="88%"
            :fullscreen="true"
             append-to-body
            >
            <!-- 用户任务 节点 -->
            <ElementEditor v-if="dialogType === 1" :taskData="taskData" :processInstance="processInstance" @hideMainSaveBtn="hideMainSaveBtn" @saveConfig="saveConfig"/>
            <!-- 连接线 -->
            <el-form  v-if="dialogType === 2" label-position="top" size="mini">
                <el-form-item label="连接类型">
                    <el-radio-group  v-model="sequenceFlowConfig.flowType" size="mini">
                        <el-radio :label="0">单向条件设置</el-radio>
                        <el-radio :label="1">变量条件设置</el-radio>
                    </el-radio-group> 
                </el-form-item>
                <el-form-item v-if="sequenceFlowConfig.flowType===0" label="操作方式">
                    <el-radio-group  v-model="sequenceFlowConfig.conditionValue"  size="mini">
                        <el-radio label="1">完成/同意</el-radio>
                        <el-radio label="2">驳回</el-radio>
                        <el-radio label="6">跳转一</el-radio>
                        <el-radio label="7">跳转二</el-radio>
                        <el-radio label="8">跳转三</el-radio>
                        <el-radio label="9">驳回并删除数据</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="sequenceFlowConfig.flowType===1" label="变量列表(在任务节点进行配置)">
                  <label v-if="!sequenceFlowConfig.conditions">暂未设置流程变量</label>
                  <el-row 
                        v-for="(condition, index2) in sequenceFlowConfig.conditions"
                        :key="condition.key" >
                        <el-col :span="1.6">
                            变量名:
                        </el-col>
                        <el-col :span="6">
                            <el-input disabled v-model="condition.varName"></el-input>
                        </el-col>
                         <el-col :span="1">
                            &nbsp;
                        </el-col>
                        <el-col :span="1.6">
                            变量表达式:
                        </el-col>
                         <el-col :span="6">
                            <el-input disabled v-model="condition.varExp" />
                        </el-col>
                    </el-row>
                </el-form-item>
                 <el-form-item v-if="sequenceFlowConfig.flowType===1" label="变量条件设置: 例 ${condition=1}" >
                   <el-tooltip  content="说明: 使用'${ }'进行设置，在两个括号中间使用变量列表里的表达式进行条件设置，例如表达式里的变量为condition，则可以设置条件：小于等于100: ${condition<=100}; 等于200: ${condition=200}; 小于300或大于500: ${condition<300||condition>500}" effect="light" placement="top">
                     <el-input  v-model="sequenceFlowConfig.conditionExpression" />
                  </el-tooltip>
                </el-form-item>
            </el-form>
            <!-- 关联子流程 -->
            <ProcessTemplate v-if="dialogType === 3" class="subProcess" :isDialogChoose="true" :callActivityConfig="callActivityConfig" :isShowOrder="true"/>
            <span slot="footer" class="dialog-footer">
              <!-- <el-button type="success" icon="el-icon-caret-right"  :loading="!isShowEleEditor" @click="handlePublishProcess">确定并发布</el-button> -->
              <el-button @click="isShowEleEditor = false">取 消</el-button>
              <el-badge class="badge-item" v-permission="permission.designProcessTemplateBtn">
                 <el-button type="primary" v-if="isShowSaveBtn" :loading="!isShowEleEditor" @click="handleSaveConfig">保存配置</el-button>
              </el-badge>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { defaultsDeep, isEmpty } from 'lodash';
    import ElementEditor from './components/ElementEditor';
    import ProcessTemplate from '@/pages/process/ProcessTemplate/ProcessTemplate';
    import { defaultElementData } from './defaultData';
    import { publishProcessService, getProcessEditUrl, getProcessDesignUrl, getProcessViewUrl, getProcessHistoryViewUrl, getProcessServiceConfig, saveProcessServiceConfig, getProcessSequenceFlowConfig, saveProcessSequenceFlowConfig, getProcessServiceSequenceFlowConditions, getProcessCallActivityConfig, saveProcessCallActivityConfig } from '@/data-model';
    import { CONST_PERMISSION_PROCESS_DESIGN_PROCESS_TEMPLATE_BTN } from '@/common/constants';

    export default {
        components: {
            ElementEditor,
            ProcessTemplate
        },
        data () {
            return {
                loadTimer: '',
                // eventData: {},
                dialogType: 1,
                isShowSaveBtn: true,
                titleView: '',
                processDefinitionId: undefined,
                processServiceId: undefined,
                pModelId: undefined,
                deploymentId: undefined,
                taskData: {},
                sequenceFlowConfig: {flowType: 0, conditionExpression: '', conditions: []},
                processId: undefined,
                editorUrl: undefined,
                isShowEleEditor: false,
                formList: [],
                processInstance: null,
                isHandlePublishProcess: false,
                callActivityConfig: {
                    processServiceId: '',
                    deploymentId: '',
                    callActivityId: '',
                    callActivityName: '',
                    calledElement: '',
                    calledElementProcessDefinitionId: '',
                    calledElementDeploymentId: '',
                    templateName: '',
                    viewOrder: 0
                },
                permission: {
                    designProcessTemplateBtn: [
                        CONST_PERMISSION_PROCESS_DESIGN_PROCESS_TEMPLATE_BTN
                    ]
                }
            };
        },
        props: {
            processType: {
                type: String
            },
            workflowProcessDefinitionId: {
                type: String
            },
            workflowProcessServiceId: {
                type: String
            },
            // pModelId: {
            //     type: String
            // },
            workflowDeploymentId: {
                type: String
            }
        },
        computed: {
            isProcessDesign () {
                return this.processType === 'design';
            },
            isProcessEdit () {
                return this.processType === 'edit';
            },
            isProcessView () {
                return this.processType === 'view';
            },
            isProcessHistoryView () {
                return this.processType === 'historyView';
            }
        },
        created () {
            this.loadTimer = new Date().getTime();
            let { processDefinitionId, processServiceId, pModelId, deploymentId } = this.$route.params;
            if (!isEmpty(this.workflowProcessDefinitionId)) {
                this.processDefinitionId = this.workflowProcessDefinitionId;
                this.processServiceId = this.workflowProcessServiceId;
                this.deploymentId = this.workflowDeploymentId;
            } else {
                this.processDefinitionId = processDefinitionId;
                this.processServiceId = processServiceId;
                this.pModelId = pModelId;
                this.deploymentId = deploymentId;
            }
            this._initPage();
            this.isShowSaveBtn = true;
        },
        methods: {
            async _initPage () {
                let activitiUrl;
                if (this.isProcessEdit) {
                    activitiUrl = await getProcessEditUrl(this.processDefinitionId + '-' + this.processServiceId);
                } else if (this.isProcessDesign) {
                    activitiUrl = await getProcessDesignUrl(this.processDefinitionId);
                } else if (this.isProcessView) {
                    activitiUrl = await getProcessViewUrl(this.processDefinitionId);
                } else if (this.isProcessHistoryView) {
                    activitiUrl = await getProcessHistoryViewUrl(this.processDefinitionId + ';' + this.pModelId);
                }
                // console.log(activitiUrl);
                this.editorUrl = activitiUrl;
                if (!this.isProcessView) {
                    this._addEventListener();
                }
            },
            async _showElement (eleData) {
                if (eleData.data.type === 'UserTask') {
                    this.showUserTask(eleData);
                } else if (eleData.data.type === 'path') {
                    this.showPath(eleData);
                    this.titleView = '网关条件设置';
                } else if (eleData.data.type === 'CallActivity') {
                    this.showSubProcess(eleData);
                    this.titleView = '关联子流程设置';
                }
            },
            async showUserTask (eleData) {
                this.loadTimer = new Date().getTime();
                let taskId = eleData.data.id;
                if (taskId) {
                    // console.log(this.processServiceId);
                    let taskData = await getProcessServiceConfig(this.processServiceId, this.deploymentId, taskId);
                    // let formData = await getFormAllConfig();
                    // this.formList = formData.data;
                    // 不全缺失的字段，并设置默认值
                    this.taskData = defaultsDeep(taskData, {
                        taskId: taskId,
                        taskName: eleData.data.name,
                        processServiceId: this.processServiceId
                    }, defaultElementData);
                    this.dialogType = 1;
                    this.taskData.executor.isInitconfig = true;
                    this.taskData.taskName = eleData.data.name;
                    this.taskData.deploymentId = this.deploymentId;
                    this.isShowEleEditor = true;
                    this.isShowSaveBtn = true;
                    this.titleView = this.taskData.taskName;

                    // 转换showAllMyApprovals的值Integer为Boolean
                    if (this.taskData.nodeInfo.approvalTemplateList && this.taskData.nodeInfo.approvalTemplateList.length > 0) {
                        this.taskData.nodeInfo.approvalTemplateList.forEach(element => {
                            element.showAllMyApprovals = (element.showAllMyApprovals > 0);
                        });
                    }
                }
            },
            async showPath (eleData) {
                this.loadTimer = new Date().getTime();
                let id = eleData.data.id;
                let config = await getProcessSequenceFlowConfig(id, this.deploymentId);
                if (!config) {
                    let conditions = [];
                    conditions = await getProcessServiceSequenceFlowConditions(this.processServiceId, this.deploymentId);
                    config = {flowType: 0, conditionExpression: '', conditions: conditions};
                }
                // console.log(config);
                config.sequenceFlowId = id;
                this.sequenceFlowConfig.conditionValue = '';
                this.sequenceFlowConfig = config;
                this.dialogType = 2;
                this.isShowEleEditor = true;
                this.isShowSaveBtn = true;
            },
            async showSubProcess (eleData) {
                this.loadTimer = new Date().getTime();
                let id = eleData.data.id;
                let name = eleData.data.name;
                let config = await getProcessCallActivityConfig(id, this.deploymentId);
                // console.log(config);
                if (!config) {
                    this.callActivityConfig.callActivityId = '';
                    this.callActivityConfig.templateName = '';
                    this.callActivityConfig.calledElement = '';
                    this.callActivityConfig.calledElementDeploymentId = '';
                } else {
                    this.callActivityConfig = config;
                }
                this.callActivityConfig.callActivityId = id;
                this.callActivityConfig.callActivityName = name;
                // config.sequenceFlowId = id;
                // this.sequenceFlowConfig.conditionValue = '';
                // this.sequenceFlowConfig = config;
                this.dialogType = 3;
                this.isShowEleEditor = true;
                this.isShowSaveBtn = true;
            },
            _addEventListener () {
                window.addEventListener('message', this._messageEvent);
            },
            _removeEventListener () {
                window.removeEventListener('message', this._messageEvent);
            },
            _messageEvent (e) {
                let eventData = e.data;
                // 只接收activiti推送的消息
                if (eventData.component && eventData.component === 'activiti') {
                    if (eventData.data && (eventData.data.type === 'UserTask' || eventData.data.type === 'path' || eventData.data.type === 'CallActivity')) {
                        this._showElement(eventData);
                    }
                }
            },
            handleCloseEleEditor (done) {
                done();
            },
            // 提供给子组件保存使用
            async saveConfig () {
                // console.log("保存配置");
                this.saveProcessServiceConfig(this.taskData).then((data) => {
                    this._initPage();
                }).catch(error => {
                    reject(new Error(error));
                });
            },
            async saveProcessServiceConfig () {
                // console.log(this.taskData);
                if (this.dialogType === 1) {
                    if (this.taskData.nodeInfo.isApproval === 1 && isEmpty(this.taskData.nodeInfo.approvalTemplateList)) {
                        this.$message({message: '当前任务为审批节点，请选择审批流模板！', type: 'warning'});
                        return;
                    }
                    if (this.taskData.nodeInfo.isSubProcess === 1 && isEmpty(this.taskData.nodeInfo.subProcesslTemplateList)) {
                        this.$message({message: '当前任务为业务流节点，请选择业务流模板！', type: 'warning'});
                        return;
                    }
                    // if (this.taskData.executor.modeType === 2 && this.taskData.executor.countersignUsers === '') {
                    //     this.$message({message: '【执行人】：会签模式下必须选择会签人员', type: 'warning'});
                    //     return;
                    // }
                    //   this.taskData.executor.candidateUsers=this.taskData.executor.candidateSelectFields.join(',');
                    //   this.taskData.executor.assigneeUsers=this.taskData.executor.assigneeSelectFields.join(',');
                    //   this.taskData.executor.participantUsers=this.taskData.executor.participantSelectFields.join(',');
                    // console.log(this.taskData.executor);
                    // return;
                    await saveProcessServiceConfig(this.taskData);
                }
            },
            async handleSaveConfig () {
                if (this.dialogType === 1) {
                    this.saveProcessServiceConfig();
                } else if (this.dialogType === 2) {
                    await saveProcessSequenceFlowConfig({
                        'processServiceId': this.processServiceId,
                        'deploymentId': this.deploymentId,
                        'sequenceFlowId': this.sequenceFlowConfig.sequenceFlowId,
                        'flowType': this.sequenceFlowConfig.flowType,
                        'conditionExpression': this.sequenceFlowConfig.conditionExpression,
                        // 'conditionExpression': '${approvedResult==' + this.sequenceFlowConfig.conditionValue + '}'
                        'conditionValue': this.sequenceFlowConfig.conditionValue
                    });
                } else if (this.dialogType === 3) {
                    this.callActivityConfig.processServiceId = this.processServiceId;
                    this.callActivityConfig.deploymentId = this.deploymentId;
                    await saveProcessCallActivityConfig(this.callActivityConfig);
                }
                if (!this.isHandlePublishProcess) {
                    this.isShowEleEditor = false;
                }
            },
            async handlePublishProcess () {
                this.isHandlePublishProcess = true;
                let loading;
                this.$confirm(`您确定要发布当前流程方案吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    await this.handleSaveConfig(true);
                    await publishProcessService(this.processServiceId, this.deploymentId);
                    loading.close();
                    this.$router.go(-1);
                }).catch((error) => {
                    loading.close();
                    console.error(error);
                });
                this.isShowEleEditor = false;
                this.isHandlePublishProcess = false;
            },
            hideMainSaveBtn (flg) {
                this.isShowSaveBtn = flg;
            }
        },
        destroyed () {
            this._removeEventListener();
        }
    };
</script>


<style lang="less">
    .workflow-editor {
        // margin-top: -6%;
        // height: 900px;
        width: 100%;
		height: 100% !important;
        // height: 100%;
        display: flex;
        flex-direction: column;
        .detailUrl-page {
            flex: 1;
            width: 100%;
            height: 900px;
        }
        .task-edit-dialog {
            width: 800px;
            min-width: 600px;
            // max-width: 1200px;
        }
        .subProcess{
            width:1000px;
            height:500px;
            margin-top: -5%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/process/ProcessEditor/WorkflowEditor.vue